import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function   Mumbaiairportcabservice() {



  const cardData = {
    keyword: " Mumbai Airport Cab Service ",


"headingDescription": "Royal Route Cab offers premium Mumbai Airport cab service, providing safe, punctual, and comfortable airport transfers for domestic and international travelers. Whether you need pickup or drop at Chhatrapati Shivaji Maharaj International Airport (BOM), we ensure a smooth, stress-free travel experience with professional drivers and well-maintained vehicles. Our service is designed for families, business travelers, tourists, and frequent flyers who value reliability and comfort. We offer 24/7 availability, real-time flight tracking, doorstep pickup, luggage assistance, and transparent pricing with no hidden charges. Our fleet includes air-conditioned sedans, SUVs, Innova, Ertiga, Kia Carens, Innova Crysta, and Tempo Travellers suitable for all travel needs. With instant booking support and professional service, Royal Route Cab is a trusted choice for Mumbai Airport cab service.",

"topPlaces": [
  {
    "title": "Mumbai Airport Cab Service",
    "description": "Mumbai airport cab service offers reliable and comfortable transportation for passengers traveling to and from Chhatrapati Shivaji Maharaj International Airport. It ensures timely pickups, professional drivers, and a hassle-free travel experience."
  },
  {
    "title": "Mumbai Airport Pickup Cab",
    "description": "Mumbai airport pickup cab service provides seamless arrival transportation for domestic and international passengers, ensuring smooth transfers from the airport to hotels, homes, or offices."
  },
  {
    "title": "Mumbai Airport Drop Cab Service",
    "description": "Mumbai airport drop cab service ensures timely and safe transportation for passengers heading to the airport. It is ideal for stress-free departures and on-time arrivals."
  },
  {
    "title": "24x7 Mumbai Airport Cab Service",
    "description": "24x7 Mumbai airport cab service is available round the clock, making it convenient for early morning flights, late-night arrivals, and emergency travel requirements."
  },
  {
    "title": "Affordable Mumbai Airport Cab",
    "description": "Affordable Mumbai airport cab service provides budget-friendly transportation options without compromising comfort, safety, and reliability for all types of travelers."
  },
  {
    "title": "Luxury Airport Cab Mumbai",
    "description": "Luxury airport cab service in Mumbai offers premium vehicles with enhanced comfort, making it ideal for business executives, VIP travelers, and special occasions."
  },
  {
    "title": "Mumbai Airport Taxi Service",
    "description": "Mumbai airport taxi service is widely used for quick and convenient travel between the airport and different parts of the city, ensuring smooth and efficient transportation."
  },
  {
    "title": "Corporate Airport Cab Mumbai",
    "description": "Corporate airport cab service in Mumbai is designed for business travelers and companies needing reliable and punctual transportation for employees and clients."
  },
  {
    "title": "One Way Airport Cab Mumbai",
    "description": "One way airport cab service in Mumbai is ideal for single-direction travel, offering convenient and cost-effective transportation to and from the airport."
  },
  {
    "title": "Premium Mumbai Airport Cab Service",
    "description": "Premium Mumbai airport cab service provides high-quality vehicles and professional chauffeurs, ensuring a comfortable and stress-free travel experience for passengers."
  }
],






services: [
  {
    name: "Mumbai Airport Outstation Cabs",
    description: "Mumbai airport outstation cabs provide reliable long-distance travel directly from airport terminals to various cities. Ideal for tourists, families, and business travelers, this service ensures smooth highway journeys. Professional drivers and clean vehicles enhance comfort. It guarantees a hassle-free travel experience."
  },
  {
    name: "Mumbai Airport Car Rental",
    description: "Mumbai airport car rental offers flexible vehicle options for local and outstation travel. Customers can choose from sedan, SUV, and luxury cars. Easy booking and transparent pricing enhance convenience. It ensures comfortable and reliable transportation."
  },
  {
    name: "Airport Taxi Mumbai",
    description: "Airport taxi Mumbai provides quick and convenient rides for airport pickups and drops. This service ensures timely travel with experienced drivers. Comfortable seating enhances the journey. It guarantees a smooth airport transfer."
  },
  {
    name: "Mumbai Airport Transfer Cabs Service",
    description: "Mumbai airport transfer cabs service ensures seamless transportation between airport and city or outstation destinations. Ideal for business and leisure travel. Professional drivers ensure punctuality. It guarantees a stress-free journey."
  },
  {
    name: "Mumbai Airport Taxi",
    description: "Mumbai airport taxi offers dependable transportation for arrivals and departures. This service includes door-to-door pickup and drop. Clean vehicles and trained drivers ensure comfort. It guarantees a reliable travel experience."
  },
  {
    name: "Airport Transfer Mumbai",
    description: "Airport transfer Mumbai provides smooth and efficient transportation services for travelers. This service ensures timely pickup and drop. Flexible booking options enhance convenience. It guarantees a comfortable journey."
  },
  {
    name: "Mumbai Airport Taxi Booking",
    description: "Mumbai airport taxi booking allows customers to reserve rides easily with instant confirmation. Travelers can select vehicle type and pickup time. Transparent pricing ensures no hidden charges. It simplifies travel planning."
  },
  {
    name: "Mumbai to Shirdi Taxi Service",
    description: "Mumbai to Shirdi taxi service offers comfortable long-distance travel for pilgrimage and family trips. This service ensures smooth highway travel with experienced drivers. Clean vehicles enhance comfort. It guarantees a peaceful journey."
  },
  {
    name: "Airport Cabs Mumbai",
    description: "Airport cabs Mumbai provide reliable transportation for airport travel needs. This service is suitable for individuals and groups. Professional drivers ensure safety and punctuality. It guarantees a smooth experience."
  },
  {
    name: "Cheapest Cab from Mumbai to Nashik",
    description: "Cheapest cab from Mumbai to Nashik offers budget-friendly intercity travel without compromising comfort. Transparent pricing ensures no hidden charges. Ideal for cost-conscious travelers. It ensures economical travel."
  },
  {
    name: "Cab from Pune to Mumbai Airport",
    description: "Cab from Pune to Mumbai airport provides direct and convenient transfer for flight travelers. This service ensures timely arrival via expressway routes. Comfortable vehicles enhance travel experience. It guarantees a hassle-free journey."
  },
  {
    name: "Mumbai to Shirdi Cab Service",
    description: "Mumbai to Shirdi cab service provides reliable travel for devotees and tourists. This service ensures comfortable seating and safe driving. Flexible pickup options enhance convenience. It guarantees a smooth journey."
  },
  {
    name: "Mumbai Airport Taxi Service",
    description: "Mumbai airport taxi service ensures dependable transportation with professional drivers and well-maintained vehicles. This service is ideal for airport transfers. It guarantees a stress-free travel experience."
  },
  {
    name: "Mumbai Airport Pickup Taxi Service",
    description: "Mumbai airport pickup taxi service provides seamless pickup from arrival terminals with flight tracking support. Drivers ensure timely service. Comfortable vehicles enhance convenience. It guarantees a smooth pickup experience."
  },
  {
    name: "Airport Transfer Mumbai International",
    description: "Airport transfer Mumbai international offers specialized services for international travelers arriving at Terminal 2. This service ensures quick pickup and smooth transfers. Professional drivers enhance reliability. It guarantees a premium experience."
  },
  {
    name: "Mumbai Airport to Shirdi Taxi Fare",
    description: "Mumbai airport to Shirdi taxi fare is transparent and competitive based on vehicle type and distance. Customers receive clear pricing before booking. No hidden charges ensure trust. It helps in planning travel expenses."
  },
  {
    name: "Mumbai Airport to Vadodara Cab",
    description: "Mumbai airport to Vadodara cab offers long-distance travel with comfortable vehicles and experienced drivers. Ideal for business and family travel. Smooth highway connectivity ensures convenience. It guarantees a reliable journey."
  },
  {
    name: "Airport Drop Pune to Mumbai",
    description: "Airport drop Pune to Mumbai service provides timely transportation for travelers heading to Mumbai airport. This service ensures punctual arrival for flights. Comfortable vehicles enhance the experience. It guarantees stress-free travel."
  },
  {
    name: "Airport Cab Booking Mumbai",
    description: "Airport cab booking Mumbai allows customers to reserve rides quickly with flexible options. Instant confirmation and transparent pricing ensure convenience. It simplifies airport travel planning."
  },
  {
    name: "Airport Pickup and Drop Mumbai",
    description: "Airport pickup and drop Mumbai provides complete transfer solutions for arrivals and departures. This service ensures timely service with professional drivers. It guarantees a smooth and comfortable journey."
  },
  {
    name: "Mumbai Airport Cab Service",
    description: "Mumbai airport cab service offers reliable and comfortable rides for all airport travel needs. This service includes pickup, drop, and outstation travel options. It guarantees a safe and convenient journey."
  },
  {
    name: "Mumbai Airport Taxi Service",
    description: "Mumbai airport taxi service provides dependable transportation with clean vehicles and experienced drivers. Ideal for all types of travelers. It ensures a smooth and hassle-free travel experience."
  },
  {
    name: "Airport Cab Mumbai",
    description: "Airport cab Mumbai offers quick and convenient booking for airport travel. This service ensures availability of vehicles at all times. Professional drivers enhance safety. It guarantees a reliable journey."
  },
  {
    name: "Mumbai Airport Taxi Booking",
    description: "Mumbai airport taxi booking provides easy and fast reservations for airport rides. Customers can select vehicle type and timing. Transparent pricing ensures trust. It simplifies travel planning."
  },
  {
    name: "Airport Taxi Service Mumbai",
    description: "Airport taxi service Mumbai ensures reliable transportation for airport travel with professional drivers and comfortable vehicles. It guarantees punctual pickups and drops for a stress-free experience."
  },
  {
    name: "Cab Service Mumbai Airport",
    description: "Cab service Mumbai airport provides flexible travel options for local, airport, and outstation journeys. Clean vehicles and trained drivers ensure comfort. It guarantees a smooth travel experience."
  },
  {
    name: "Mumbai Airport Pickup Cab",
    description: "Mumbai airport pickup cab offers seamless pickup services from airport terminals. Drivers track flight timings to ensure punctual service. Comfortable vehicles enhance travel convenience. It guarantees a smooth transfer."
  }
],

tableData: [
  ["Mumbai Airport Outstation Cabs", "Mumbai Airport Car Rental"],
  ["Airport Taxi Mumbai", "Mumbai Airport Transfer Cabs Service"],
  ["Mumbai Airport Taxi", "Airport Transfer Mumbai"],
  ["Mumbai Airport Taxi Booking", "Mumbai to Shirdi Taxi Service"],
  ["Airport Cabs Mumbai", "Cheapest Cab from Mumbai to Nashik"],
  ["Cab from Pune to Mumbai Airport", "Mumbai to Shirdi Cab Service"],
  ["Mumbai Airport Taxi Service", "Mumbai Airport Pickup Taxi Service"],
  ["Airport Transfer Mumbai International", "Mumbai Airport to Shirdi Taxi Fare"],
  ["Mumbai Airport to Vadodara Cab", "Airport Drop Pune to Mumbai"],
  ["Airport Cab Booking Mumbai", "Airport Pickup and Drop Mumbai"],
  ["Mumbai Airport Cab Service", "Airport Cab Mumbai"],
  ["Mumbai Airport Taxi Booking", "Airport Taxi Service Mumbai"],
  ["Cab Service Mumbai Airport", "Mumbai Airport Pickup Cab"]
],


whychoose: [
  {
    WhyChooseheading: "Reliable Mumbai Airport Cab Service",
    WhyChoosedescription: "Royal Route Cabs offers dependable cab service to and from Mumbai Airport for smooth and hassle-free travel."
  },
  {
    WhyChooseheading: "On-Time Pickup with Flight Tracking",
    WhyChoosedescription: "We track flight timings to ensure timely pickup even during delays, making your airport transfer stress-free."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Our Mumbai Airport cab service operates round the clock for late-night arrivals and early morning departures."
  },
  {
    WhyChooseheading: "Professional & Experienced Drivers",
    WhyChoosedescription: "Our drivers are trained, courteous, and experienced in airport routes, ensuring safe and comfortable travel."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs provides clear pricing including tolls and parking charges with no hidden costs."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well-maintained, and sanitized regularly for a comfortable ride."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Choose from sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers for group travel."
  },
  {
    WhyChooseheading: "Trusted Airport Transfer Service",
    WhyChoosedescription: "Royal Route Cabs is trusted by travelers for reliable Mumbai Airport cab bookings with punctual service and smooth experience."
  }
]

};

const faqData = [
  { question: "Do you provide Mumbai Airport cab service?", answer: "Yes, Royal Route Cabs offers reliable cab services for pickup and drop at Mumbai Airport." },
  { question: "Which terminals do you cover?", answer: "We provide service for both Terminal 1 and Terminal 2 of Mumbai Airport." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our Mumbai Airport cab service operates 24/7." },
  { question: "Do you track flight delays?", answer: "Yes, we monitor flight timings to ensure timely pickup." },
  { question: "Which vehicles are available?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, and Tempo Travellers." },
  { question: "Can I book one-way airport cab?", answer: "Yes, we provide one-way and round-trip airport cab services." },
  { question: "Do you provide pickup from all areas?", answer: "Yes, we provide pickup from Mumbai, Navi Mumbai, Thane, and nearby locations." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended for guaranteed availability." },
  { question: "Do you provide doorstep pickup and drop?", answer: "Yes, we provide pickup and drop from home, hotel, and office." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Karan Mehta",
    feedback: "Mumbai Airport cab service with Royal Route Cabs was very punctual and reliable. The driver was already waiting and the ride was smooth and comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Anjali Desai",
    feedback: "Excellent airport cab experience in Mumbai. The vehicle was clean, pickup was on time, and the entire journey felt safe and hassle-free.",
    rating: 5
  }
];









  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai Airport Cab Service",
  "image": "https://www.royalroutecabs.com/assets/images/mumbai-airport-cab-service.jpg", // replace if needed
  "description": "Book Mumbai Airport Cab Service with Royal Route Cabs for reliable airport pickup and drop, outstation transfers, and 24x7 taxi service. Available for Mumbai Airport to Pune, Nashik, Shirdi, Vadodara, and other intercity routes with sedan, SUV, Innova, and premium cars.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "999", // starting airport transfer fare (adjust if needed)
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/mumbai-airport-cab-service"
  }
};






  return (
    <div>
<Helmet>
  <title>Mumbai Airport Cab Service | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Mumbai Airport Cab Service with Royal Route Cabs. 24x7 reliable airport pickup, drop, and outstation taxi service to Pune, Nashik, Shirdi, Vadodara and more."
  />

  <meta
    name="keywords"
    content="mumbai airport cab service, mumbai airport outstation cabs, mumbai airport car rental, airport taxi mumbai, mumbai airport transfer cabs service, airport transfer mumbai, mumbai airport taxi booking, airport cabs mumbai, cheapest cab from mumbai to nasik, cab from pune to mumbai airport, mumbai to shirdi taxi service, mumbai airport taxi service, airport pickup taxi service mumbai, airport drop pune to mumbai, mumbai airport pickup cab, mumbai airport drop taxi, airport cab booking mumbai, airport pickup and drop mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/79.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaiairportcabservice;